

















































import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import SearchField from './SearchField'
import main from '../main'

@Component({
  components: { SearchField },
  computed:
    mapGetters([
      'language',
      'busy'
    ])
})
export default class Topbar extends Vue {
  sideIconClick () {
    console.log('sideIconClick', this)
  }
  onLanguageClick (lang:string) {
    main.store.commit('language', lang)
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Topbar.vue